import FormattedMessage from 'I18n/components/FormattedMessage';
import * as RequestStatusTypes from '../../constants/RequestStatusTypes';
import { View } from 'foundations-components/components/View';
import PresetTile from './PresetTile';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `theme-previewer.themePresets.${key}`;
const ActiveThemePresetCard = ({
  activeThemePresetId,
  presetsRequestStatus,
  onBrowsePresetsClick,
  themePath
}) => {
  if (presetsRequestStatus === RequestStatusTypes.PENDING) {
    return /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        size: "small",
        grow: true
      })
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "200",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(PresetTile, {
      onClick: onBrowsePresetsClick,
      presetId: activeThemePresetId,
      themePath: themePath
    }), /*#__PURE__*/_jsx(Button, {
      onClick: onBrowsePresetsClick,
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('browsePresets')
      })
    })]
  });
};
export default ActiveThemePresetCard;